import "../list.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.QuestionList = class QuestionList extends AssessmentBuilder.Views.List {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize({ sortable: true });
    this.listenTo(this.collection, "add remove", this.render);
    return (this.selected = []);
  }
};
AssessmentBuilder.Views.QuestionList.prototype.tagName = "question-list";
AssessmentBuilder.Views.QuestionList.prototype.selectedCss = "selected";
AssessmentBuilder.Views.QuestionList.prototype.listItemViewClass = "AssessmentBuilder.Views.Question";
